import { GetStaticProps } from 'next'
import { paths } from '@/constants/paths'
import { getBasicPageMetaData, Seo } from '@/layout/Seo'
import { HideTopNavigationLayout, NextPageWithLayout } from '@/layouts'
import { getGenericStaticPaths } from '@/utils/GetGenericStaticPaths'
import { getLocaleFromParams } from '@/utils/LocaleUtil'
import { getStaticPropsErrorHandler, getUrlFromThisFilePath } from '@/utils/nextUtils/nextErrorHandlers'
import { useTranslate } from '@/utils/translate/translate-client'
import { loadTranslations } from '@/utils/translate/translate-server'
import { GuildCreateIndexView } from '@/views/GuildCreateView'

interface GuildCreateProps {
  locale: string
}

const GuildCreateIndexPage: NextPageWithLayout<GuildCreateProps> = ({ locale }) => {
  const { t } = useTranslate('guild-create')

  return (
    <div className="bg-white">
      <Seo
        /* todo - remove this when the page is live and update the redirect from /create to here */
        noindex
        nofollow={false}
        {...getBasicPageMetaData({
          cloudinaryImagePath: 'v1717006540/open-graph-240228.jpg',
          cloudinaryTransformation: 'b_rgb:000000',
          description: t('guildCreateIndexMetaDescription', 'Submit your film or concept to the Angel Studios Guild.'),
          locale,
          path: paths.guild.create.index,
          title: t('guildCreateIndexTitle', 'Angel Guild Film Submission | Angel Studios'),
        })}
      />
      <GuildCreateIndexView />
    </div>
  )
}

GuildCreateIndexPage.getLayout = (page) => {
  return <HideTopNavigationLayout isDarkMode={false}>{page}</HideTopNavigationLayout>
}

export const getStaticProps: GetStaticProps = async ({ params }) =>
  getStaticPropsErrorHandler({ requestUrl: getUrlFromThisFilePath(params) }, async () => {
    const locale = getLocaleFromParams(params)

    return {
      props: {
        locale,
        ...(await loadTranslations(locale, ['common', 'guild-create'])),
      },
    }
  })

export const getStaticPaths = getGenericStaticPaths

export default GuildCreateIndexPage
